import {createReducer} from '@reduxjs/toolkit'
import {EventMembers} from '@wix/ambassador-events-ui-v1-widget-data/types'

export interface MembersState {
  members: Record<string, EventMembers>
}

const defaultState: MembersState = {
  members: {},
}

export const members = createReducer(defaultState, _builder => {})
